import localCart from "../../assets/js/cart-service";
import axios from "axios";

export default function(appConfig) {
  const cartModule = {
    namespaced: true,
    state: {
      items: [],
      location: null,
      address: null,
      billing: null,
      paymentMode: null,
      contactNumber: null,
      checkoutUrl: null,
      checkoutError: null,
      checkoutInProgress: false
    },
    getters: {
      isValid(state) {
        return (
          state.items.length > 0 &&
          state.address &&
          state.contactNumber &&
          state.contactNumber.length &&
          ["cash", "bank"].indexOf(state.paymentMode) > -1
        );
      },
      itemTotal(state, getters, rootState) {
        if (!state.items.length) {
          return 0;
        }

        let totals = state.items.map(item => {
          return item.quantity * item.price;
        });

        return totals.reduce((total, current) => {
          return total + current;
        });
      },
      cartTotal(state, getters, rootState) {
        return getters["itemTotal"];
      }
    },
    mutations: {
      updateCartItems(state, items) {
        state.items = items || [];
      },
      setAddress(state, address) {
        state.address = address;
      },
      setAddressBilling (state, address) {
        state.billing = address
      },

      updateContactNumber(state, contactNumber) {
        state.contactNumber = contactNumber;
      },
      updatePaymentMode(state, paymentMode) {
        state.paymentMode = paymentMode;
      },
      addItemQuantity(state, { index, quantity }) {
        state.items[index].quantity =
          (quantity || 1) + state.items[index].quantity || 1;
      },
      addItemToCart(state, item) {
        const index = state.items.findIndex(cItem => cItem.id === item.id);
        if (index >= 0) {
          state.items[index].quantity += item.quantity;
        } else {
          state.items.push(item);
        }
      },
      removeItemFromCart(state, index) {
        state.items.splice(index, 1);
      },
      setLocation(state, location) {
        state.location = location;
      }
    },
    actions: {
      setLocation(context, location) {
        context.commit("setLocation", location);
        context.dispatch("saveCart");
      },
      setAddressBilling (context, address) {
        context.commit('setAddressBilling', address)
        context.dispatch('saveCart')
      },

      setAddress(context, address) {
        context.commit("setAddress", address);
        context.dispatch("saveCart");
      },
      setContactNumber(context, contactNumber) {
        context.commit("updateContactNumber", contactNumber);
        context.dispatch("saveCart");
      },
      setPaymentMode(context, paymentMode) {
        context.commit("updatePaymentMode", paymentMode);
        context.dispatch("saveCart");
      },
      userChanged(store, user) {
        store.dispatch("restoreCart");
      },
      clearCart(store) {
        localCart.clearCart();
        store.commit("updateCartItems", []);
        store.commit("setAddress", null);
        store.commit("updatePaymentMode", null);
        store.commit("updateContactNumber", null);
        store.dispatch("saveCart");
      },
      restoreCart(store, order) {
        store.dispatch("restoreLocalCart");
        store.dispatch("restoreCloudCart");
      },
      restoreLocalCart(store) {
        store.dispatch("updateCart", localCart.get());
      },
      restoreCloudCart(store) {
        if (store.rootState.auth.user) {
          store
            .dispatch("auth/getAccessToken", null, { root: true })
            .then(accessToken => {
              return axios.get(
                `${appConfig.API_URL}/customers/${store.rootState.auth.user.uid}/cart`,
                {
                  headers: {
                    Authorization: "Bearer " + accessToken
                  }
                }
              );
            })
            .then(result => {
              store.dispatch("updateCart", result.data);
            });
        }
      },
      updateCart(store, cart) {
        if (!cart) {
          return;
        }
        store.commit("updateCartItems", cart.items);
        let options = cart.options || [];
        options.forEach(option => {
          if (option.type === "delivery:address" && option.value) {
            const addresses = store.rootGetters["customer/friendlyAddresses"];

            if (addresses.length >= 1) {
              store.commit("setAddress", addresses[0]);
            }
            // const isValidAddress = addresses.some(address => {
            //   return address.id === option.value.id && address.name === option.value.name
            // })

            // if (isValidAddress) {
            //   store.commit('setAddress', option.value)
            // }
          } else if (option.type === "delivery:contact") {
            store.commit("updateContactNumber", option.value);
          } else if (option.type === "payment:mode") {
            store.commit("updatePaymentMode", option.value);
          } else if (option.type === "delivery:location") {
            store.commit("setLocation", option.value);
          }
        });
      },
      addToCart(store, options) {
        const quantity = parseInt(options.quantity) || 1;
        if (typeof options.index !== "undefined") {
          if (store.state.items.length - 1 < options.index) {
            return;
          }

          store.commit("addItemQuantity", {
            index: options.index,
            quantity: options.quantity
          });
        } else {
          let item = {
            id: options.product.id,
            variantCode: options.product.variantCode,
            name: options.product.parent.name,
            price: options.product.price,
            supplier: {
              id: options.product.supplier.id,
              code: options.product.supplier.code,
              name: options.product.supplier.name
            },
            shop: options.product.shop,
            quantity: quantity,
            options: options.options
          };

          store.commit("addItemToCart", item);
        }
        store.dispatch("saveCart");
      },
      removeFromCart(store, options) {
        store.commit("removeItemFromCart", options.index);
        store.dispatch("saveCart");
        // store.dispatch('checkout')
      },
      saveCart(store) {
        let options = [
          {
            type: "delivery:location",
            value: store.state.location
          },
          {
            type: "delivery:contact",
            value: store.state.contactNumber
          },
          {
            type: "delivery:address",
            value: store.state.address
          },
          {
            type: "delivery:mode",
            value: "door-to-door"
          },
          {
            type: "delivery:schedule:range"
          },
          {
            type: "payment:mode",
            value: store.state.paymentMode
          }
        ];

        const cart = {
          items: store.state.items,
          options: options
        };

        localCart.save(cart);
        if (store.rootState.auth.user) {
          return store
            .dispatch("auth/getAccessToken", null, { root: true })
            .then(accessToken => {
              return axios.post(
                `${appConfig.API_URL}/customers/${store.rootState.auth.user.uid}/cart`,
                cart,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              );
            });
        }
      },
      checkout(store) {
        let options = [
          {
            type: "delivery:contact",
            value: store.state.contactNumber
          },
          {
            type: "delivery:address",
            value: {
              name: store.state.address.name
            }
          },
          {
            type: "delivery:mode",
            value: "door-to-door"
          },
          {
            type: "delivery:schedule",
            value: "range"
          },
          {
            type: "payment:mode",
            value: store.state.paymentMode
          }
        ];

        let body = {
          items: store.state.items,
          options: options
        };

        return store
          .dispatch("auth/getAccessToken", null, { root: true })
          .then(accessToken => {
            return axios
              .post(
                `${appConfig.API_URL}/customers/${store.rootState.auth.user.uid}/orders`,
                body,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              )
              .then(result => {
                store.dispatch("clearCart");
                return result.data;
              });
          });
      }
    }
  };
  return cartModule;
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js